<template>
	<div class="form__group">
		<TreeSelect
            v-model="selected"
            :options="options"
            :searchable="true"
            :always-open="false"
            :load-options="loadOptions"
            :flattenSearchResults="true"
            placeholder="Select..."
            :normalizer="normalizer"
            :valueFormat="valueFormat"
            :class="{
                'form__control': true,
                'form__control--invalid': errors.first(this.name)
            }"
        />
		<label class="form__label">{{ label }}</label>
		<div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import TreeSelect from '@riophae/vue-treeselect';
	import API from '@api';

	export default {
		inject: {
			$validator: '$validator'
		},
		$_veeValidate: {
			value() {
				return this.selected;
			},
			name() {
				return this.name;
			},
		},
		name: 'FormControlInsightCategory',
		components: {
			TreeSelect
		},
		props: {
			value: {
				required: true,
			},
			name: {
				type: String,
				required: true,
			},
			label: {
				type: String,
				default: 'Select folder location',
			},
            valueFormat: {
                type: String,
                default: 'id',
            }
		},
		data() {
			return {
				options: null,
				selected: this.value || null,
			}
		},
		methods: {
			async loadOptions({ action, parentNode, callback, instanceId }) {
                try {
                    switch(action) {
                        case 'LOAD_CHILDREN_OPTIONS':
                            // FIXME
                            // parentNode.children = await API.getSubSectors(parentNode.id);
                            break;
                        case 'LOAD_ROOT_OPTIONS':
                            this.options = await API.getInsightCategories();
                            break;
                    }
                    callback();
                } catch(err){
                    callback(new Error('Failed to load options: network error.'))
                }
			},
			normalizer(node) {
				let normalized =  {
					id: node.id,
					label: node.name,
                    isDisabled: false,
                    isDefaultExpanded: (this.selected && this.selected.id === node.id)
				};

                normalized.isDefaultExpanded = (this.selected && this.selected.id === node.id);

				if(node.children && node.children.length) {
					normalized.children = node.children;
				}

				return normalized;
			},
		},
		watch: {
			selected(selected) {
				this.$emit('input', selected);
			},
			value(value) {
                this.selected = value;
			},
		},
	}
</script>
